export default {
      id: "about-icon-2_color-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "sprite.svg#about-icon-2_color",
      toString: function () {
        return this.url;
      }
    }